import React from 'react'
import {Form, Col, FormGroup, Button} from 'react-bootstrap'
import DoubleTextFieldTranslator from './DoubleTextFieldTranslator'
import apiAddress from '../../../utils/APIEndPointAddress'
import './ImageForm.css'

export default ({submitForm, getValue, setValue}) => {
  return (
    <Form id="qq-form" action={`${apiAddress}horse/add-photo`} horizontal onSubmit={submitForm}>
      <DoubleTextFieldTranslator name="title" nameFa="title_fa" placeholder="عنوان تصویر" setter={setValue} getter={getValue} />

      <DoubleTextFieldTranslator name="description" nameFa="description_fa" placeholder="توضیحات" setter={setValue} getter={getValue} />

      <FormGroup>
        <Col xsOffset={4} xs={7}>
          <Button type="submit" className="btnBlock" bsStyle="success">
             آپلود و ذخیره
          </Button>
        </Col>
      </FormGroup>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/HorseInfo/ImageForm/ImageForm.js